import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import 'rxjs/add/operator/map';
import { globalValues } from '@app/globals';
import { CustomHttp } from '@service/customhttp.service';
import { RequestLibraryService } from '@service/core/request-library.service';
import { HttpClient } from '@angular/common/http';


@Injectable()
export class CallFilterService {
    private customHttp: CustomHttp;
    constructor(
        private http: HttpClient,
        private router: Router,
        private requestLibrary: RequestLibraryService
    ) {
        this.customHttp = new CustomHttp(http, router);
    }
    postCallFilters(model) {
        return this.requestLibrary.Post('/callfilters', model);
    }

    getCallFilters() {
        return this.requestLibrary.Get('/callfilters');
    }

    deleteFilters(filter: string) {
        return this.requestLibrary.Delete('/callfilters/' + filter);
    }
}
